<section class="body">
  <header class="header d-flex justify-content-between">
    <div class="logo-container">
      <a (click)="onLogoClick()" class="logo" style="margin-top: 5px">
        <img src="assets/images/Pitten.svg" alt="PITTEN" />
      </a>
    </div>

    @if(!isTokenGenerated) {
    <!-- This language picker is temporarily also placed in the login-page.html, create-profile.html and forgot-pasword.html files-->
    <div class="customer-language-picker-area">
      <div class="picker-label">
        <label class="switch">
          <input
            type="checkbox"
            (change)="useLang($event.target.checked ? 'en' : 'da')"
            [checked]="currentLang === 'en'"
            />
          <span class="slider round">
            <span class="lang lang-da">Dansk</span>
            <span class="slider-color"></span>
            <span class="lang lang-en">English</span>
          </span>
        </label>
      </div>
    </div>
  }

  </header>
  <div class="inner-wrapper">
      <section role="main" class="content-body">
        <router-outlet></router-outlet>
      </section>
    </div>
  </section>
